import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import listingTypologyMultiSelect from "@vueEntry/listingTypologyMultiSelect.vue";
//@ts-ignore
import PlaceBox from "./PlaceBox.vue";
import { PLACE_TYPE } from "@customTypes/PlaceType";
import { getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import { useSearchBeanPlace } from "@wkComposables/useSearchBeanPlace";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import { isSafari } from "@utils/DeviceDetection";
import { CONTRACT } from "@customTypes/ContractEnum";
//@ts-ignore
import { TABTYPE as _TABTYPE } from "@customTypes/HomeTabTypeEnum";
import { defineComponent, defineAsyncComponent } from "vue";
//@ts-ignore
import { useValuationPlaceStore } from "@store/ValuationPlaceStore";
//@ts-ignore
import { redirectToValuation } from "@wkWebSrc/js/valuation/valuationCookie";
import { mapState, mapActions, mapWritableState } from "pinia";
import { useSearchBeanStore } from "@store/SearchBeanStore";
import { useHomeTabStore } from "@wkWebSrc/js/store";
import { deepCopy } from "@utils/ObjectUtils";
//@ts-ignore
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
export default defineComponent({
  name: "SearchBoxHome",
  components: {
    BaseButton: BaseButton,
    BaseInput: BaseInput,
    listingTypologyMultiSelect: listingTypologyMultiSelect,
    AccessibleSelect: AccessibleSelect,
    PlaceBox: PlaceBox,
    BaseDropDown: BaseDropDown,
    MapModal: defineAsyncComponent(function () {
      return import("@vmodals/MapModal.vue");
    }),
    FiltersAgencyModal: defineAsyncComponent(function () {
      return import("@vmodals/FiltersAgencyModal.vue");
    }),
    AuctionFilters: defineAsyncComponent(function () {
      return import("@vueEntry/AuctionFilters.vue");
    })
  },
  props: {
    expand: {
      type: Boolean,
      "default": false
    },
    isHome: {
      type: Boolean,
      "default": false
    },
    not_found: {
      type: Boolean,
      "default": false
    },
    valuation_tab: {
      type: Boolean,
      "default": true
    },
    trend_tab: {
      type: Boolean,
      "default": true
    },
    sell_tab: {
      type: Boolean,
      "default": true
    },
    auction_tab: {
      type: Boolean,
      "default": true
    },
    agency_tab: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["is-agency-active", "is-auction-active"],
  setup: function setup() {
    var _useSearch = useSearch(),
      search = _useSearch.search;
    var _useSearchBeanPlace = useSearchBeanPlace(),
      updateSearchBeanBySearchPlace = _useSearchBeanPlace.updateSearchBeanBySearchPlace,
      updateSearchBeanByMapPlace = _useSearchBeanPlace.updateSearchBeanByMapPlace;
    return {
      search: search,
      //useSearchBeanPlace
      updateSearchBeanBySearchPlace: updateSearchBeanBySearchPlace,
      updateSearchBeanByMapPlace: updateSearchBeanByMapPlace
    };
  },
  data: function data() {
    return {
      agencySelected: {},
      isValuationOrSellingLoading: false,
      isSearchLoading: false,
      forceCloseMultiTypology: false,
      forceClosePlace: false,
      modal: null,
      place: null,
      cityURL: "",
      showMapBtn: false,
      forceSearch: false,
      agencyFilter: {
        name: "",
        franchiseId: null,
        uri: ""
      },
      auctionFiltersSearchBean: {}
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    TABTYPE: function TABTYPE() {
      return _TABTYPE;
    },
    placeTypes: function placeTypes() {
      return this.isAgencyActive ? "C,P,Z,L,R" : "C,P,Z,L,I,R,A";
    },
    cdn: function cdn() {
      return window["_cdn"];
    },
    labels: function labels() {
      return window["_labels"];
    },
    //TODO: da controllare in quanto è possibile che non serva più (filtri solo in listato)
    isSearchReady: function isSearchReady() {
      var _a, _b;
      return !!(((_a = this.searchBean) === null || _a === void 0 ? void 0 : _a.cityURL) || ((_b = this.searchBean) === null || _b === void 0 ? void 0 : _b.polygonFromMap));
    },
    isValuationReady: function isValuationReady() {
      var _a;
      return !!((_a = this.valuationPlace) === null || _a === void 0 ? void 0 : _a.address);
    },
    hasSearchError: function hasSearchError() {
      return this.forceSearch && !this.isSearchReady;
    },
    hasValuationError: function hasValuationError() {
      var _a;
      return this.forceSearch && !((_a = this.valuationPlace) === null || _a === void 0 ? void 0 : _a.address);
    },
    listingTypologies: function listingTypologies() {
      return this.getOptions("listingTypologies");
    },
    isSearchActive: function isSearchActive() {
      return this.isTabActive(_TABTYPE.SALE) || this.isTabActive(_TABTYPE.RENT) || this.isTabActive(_TABTYPE.AUCTION);
    },
    isAgencyActive: function isAgencyActive() {
      return this.isTabActive(_TABTYPE.AGENCY);
    },
    isAuctionActive: function isAuctionActive() {
      return this.isTabActive(_TABTYPE.AUCTION);
    },
    isValuationActive: function isValuationActive() {
      return this.isTabActive(_TABTYPE.VALUATE);
    },
    isSellingActive: function isSellingActive() {
      return this.isTabActive(_TABTYPE.SELLING);
    },
    isTrendActive: function isTrendActive() {
      return this.isTabActive(_TABTYPE.TREND);
    },
    customListingTypologyURL: function customListingTypologyURL() {
      return this.isAgencyActive ? this.agencyListingTypologyURL : this.isTrendActive ? this.trendListingTypologyURL : "";
    },
    useContractType: function useContractType() {
      return !(this.isAgencyActive || this.isTrendActive);
    },
    agencyListingTypologyURL: function agencyListingTypologyURL() {
      return this.labels.macroTypology_url_5;
    },
    trendListingTypologyURL: function trendListingTypologyURL() {
      return this.labels.trend_url;
    },
    franchiseList: function franchiseList() {
      return this.getOptions("franchiseList");
    }
  }, mapState(useValuationPlaceStore, ["valuationAddressLoading", "valuationPlace"])), mapState(useSearchBeanStore, ["searchBean", "realEstateCounter"])), mapWritableState(useHomeTabStore, ["activeTab"])),
  watch: {
    activeTab: function activeTab(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateContractType(newValue);
      }
    }
  },
  created: function created() {
    var defaultFranchise = this.franchiseList[0];
    this.selectedGroupAgency(defaultFranchise);
    //Setting the first option as default
    this.agencySelected = defaultFranchise;
    if (window.location.href.includes("affitto-case")) this.activeTab = _TABTYPE.RENT;
    if (window.location.href.includes("asta-case")) {
      this.activeTab = _TABTYPE.AUCTION;
      this.setAuctionTabActive();
    }
    if (window.location.href.includes("agenzie-immobiliari")) this.setAgencyTabActive();
  },
  mounted: function mounted() {
    var _this = this;
    if (isSafari()) {
      window.onpageshow = function (event) {
        if (event.persisted) {
          _this.isSearchLoading = true;
          _this.isSearchLoading = false;
        }
      };
    }
    this.auctionFiltersSearchBean = deepCopy(this.searchBean);
  },
  methods: Object.assign(Object.assign({
    closePlaceDropdown: function closePlaceDropdown() {
      this.forceCloseMultiTypology = false;
      this.forceClosePlace = true;
    },
    closeMultiListingTypology: function closeMultiListingTypology() {
      this.forceClosePlace = false;
      if (!this.isAgencyActive) {
        this.forceCloseMultiTypology = true;
        return;
      }
      this.closeAgencyFranchiseList();
    },
    closeAgencyFranchiseList: function closeAgencyFranchiseList() {
      var dropdownMenuAgency = this.$refs.dropdownMenuAgency;
      var dropdownToggleAgency = this.$refs.dropdownToggleAgency;
      if (dropdownMenuAgency === null || dropdownMenuAgency === void 0 ? void 0 : dropdownMenuAgency.classList.contains("show")) dropdownMenuAgency === null || dropdownMenuAgency === void 0 ? void 0 : dropdownMenuAgency.classList.remove("show");
      if (dropdownToggleAgency === null || dropdownToggleAgency === void 0 ? void 0 : dropdownToggleAgency.classList.contains("show")) dropdownToggleAgency === null || dropdownToggleAgency === void 0 ? void 0 : dropdownToggleAgency.classList.remove("show");
    },
    setAgencyTabActive: function setAgencyTabActive() {
      this.setActiveTab(_TABTYPE.AGENCY);
      this.resetPlaceIfNecessary();
    },
    setAuctionTabActive: function setAuctionTabActive() {
      this.setActiveTab(_TABTYPE.AUCTION);
      this.resetPlaceIfNecessary();
    },
    resetPlaceIfNecessary: function resetPlaceIfNecessary() {
      if (this.searchBean.placeType == PLACE_TYPE.AREA_OF_INTEREST) this.setSearchBean(getDefaultSearchBean());
    },
    onLTMSChange: function onLTMSChange(options) {
      this.searchBean.macroTypologyId = options.macroTypologyID;
      this.searchBean.listingTypologyURL = options.url;
      this.searchBean.listingTypologyId = options.listingTypologyId;
      this.searchBean.listingTypologyIdList = options.selectedListingTypologiesIDList;
      this.searchBean.typologyIdList = options.selectedTypologiesIDList;
      this.auctionFiltersSearchBean.macroTypologyId = options.macroTypologyID;
      this.auctionFiltersSearchBean.listingTypologyURL = options.url;
      this.auctionFiltersSearchBean.listingTypologyId = options.listingTypologyId;
      this.auctionFiltersSearchBean.listingTypologyIdList = options.selectedListingTypologiesIDList;
      this.auctionFiltersSearchBean.typologyIdList = options.selectedTypologiesIDList;
    },
    openModal: function openModal(modal) {
      this.modal = modal;
    },
    closeModal: function closeModal() {
      this.modal = null;
    },
    setActiveTab: function setActiveTab(tabElement) {
      this.activeTab = tabElement;
    },
    handleSearch: function handleSearch() {
      this.forceSearch = true;
      this.isSearchLoading = true;
      if (this.hasSearchError) {
        this.isSearchLoading = false;
        return;
      }
      this.forceClosePlace = true;
      this.isAgencyActive ? this.closeAgencyFranchiseList() : this.forceCloseMultiTypology = true;
      if (this.isAuctionActive) {
        this.updateSearchBean(this.auctionFiltersSearchBean);
      }
      this.search(true, this.customListingTypologyURL, this.useContractType, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null);
    },
    valuationRedirect: function valuationRedirect(isSelling) {
      this.isValuationOrSellingLoading = true;
      this.forceSearch = true;
      if (this.hasValuationError) {
        this.isValuationOrSellingLoading = false;
        return;
      }
      this.forceClosePlace = true;
      this.forceCloseMultiTypology = true;
      redirectToValuation(this.valuationPlace, 1, isSelling);
    },
    updateContractType: function updateContractType(contractType) {
      this.forceSearch = false;
      this.forceCloseMultiTypology = false;
      this.forceClosePlace = false;
      this.$emit("is-agency-active", this.isAgencyActive);
      this.$emit("is-auction-active", this.isAuctionActive);
      switch (contractType) {
        case _TABTYPE.SALE:
          this.updateSearchBean({
            sale: true,
            rent: false,
            contractType: CONTRACT.SALE,
            auctionType: 0
          });
          break;
        case _TABTYPE.RENT:
          this.updateSearchBean({
            sale: false,
            rent: true,
            contractType: CONTRACT.RENT,
            auctionType: 0
          });
          break;
        case _TABTYPE.AUCTION:
          this.updateSearchBean({
            sale: false,
            rent: false,
            contractType: CONTRACT.AUCTION,
            auctionType: 1
          });
          this.auctionFiltersSearchBean.sale = false;
          this.auctionFiltersSearchBean.rent = false;
          this.auctionFiltersSearchBean.contractType = 3;
          this.auctionFiltersSearchBean.auctionType = 1;
          break;
        case _TABTYPE.AGENCY:
          // TODO resettare place se è Area di interesse o locality
          this.updateSearchBean({
            sale: false,
            rent: false,
            contractType: undefined,
            auctionType: 0
          });
          break;
        case _TABTYPE.VALUATE:
          this.updateSearchBean({
            sale: false,
            rent: false
          });
          break;
        case _TABTYPE.SELLING:
          this.updateSearchBean({
            sale: false,
            rent: false
          });
          break;
        case _TABTYPE.TREND:
          break;
        default:
          this.updateSearchBean({
            sale: true,
            rent: false,
            contractType: CONTRACT.SALE
          });
      }
    },
    getOptions: function getOptions(key) {
      return window["_options"][key];
    },
    getPlaceFromModal: function getPlaceFromModal(obj) {
      this.closeModal();
      if (!obj.place) return;
      this.place = obj.place;
      this.updateSearchBeanBySearchPlace(obj, false);
    },
    getPlaceFromMapModal: function getPlaceFromMapModal(obj) {
      this.closeModal();
      this.updateSearchBeanByMapPlace({
        polygon: obj.polygon,
        polygonForDB: obj.polygonForDB
      });
    },
    saveFilterAgency: function saveFilterAgency(agencyFilter) {
      this.agencyFilter = Object.assign({}, agencyFilter);
      this.modal = null;
    },
    selectedGroupAgency: function selectedGroupAgency(franchise) {
      this.agencyFilter.franchiseId = franchise.id;
      this.agencyFilter.uri = franchise.uri || "";
      franchise.visibleLabel = "".concat(this.labels["generic_group"], " - ").concat(franchise.label);
      this.closeAgencyFranchiseList();
    },
    onChangedAuctionFiltersSearchBean: function onChangedAuctionFiltersSearchBean(searchBean) {
      this.auctionFiltersSearchBean = Object.assign(Object.assign({}, this.auctionFiltersSearchBean), searchBean);
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean", "updateRESBCounter"])), mapActions(useHomeTabStore, ["isTabActive"]))
});